(function () {
  // 这个文件是主题自绘的收藏按钮，桥接到 Wishlist King 的 <wishlist-button-block>。
  // 之所以要自己加载该组件：我们没有在页面上放 app 自带的 Wishlist Button 区块
  // （按钮的位置和样式是主题自定义的），app 便不会下发 block-wishlist-button.js。
  //
  // 该 URL 原先写死在 220 版，而 app 其余部分早已是 254 —— 版本错配，接口一变
  // 就会静默失效。app 自己在 window.WishlistKingAppLoaderURL 上给出了当前版本的
  // app-loader.js 地址，同目录下就是我们要的组件，据此推导即可自动跟随版本。
  // 下面那个常量只作为兜底，正常路径不会用到。
  //
  // 时序无竞态：该全局变量由 app embed 的普通内联 <script> 在解析时赋值，
  // 而本文件是 defer 加载的，整份文档解析完才执行。所以哪怕那段内联脚本在
  // 文档里的位置比本文件的 <script> 标签更靠后，它也一定先跑。不需要轮询等待。
  const SWISH_SCRIPT_FALLBACK = 'https://cdn.shopify.com/extensions/019ce26a-bb73-7ec7-a00f-cef8cb945806/swish-wishlist-king-220/assets/block-wishlist-button.js';
  let swishScriptPromise;

  function resolveSwishScriptSrc() {
    const loaderUrl = window.WishlistKingAppLoaderURL;
    if (typeof loaderUrl === 'string' && loaderUrl.indexOf('app-loader.js') > -1) {
      return loaderUrl.replace('app-loader.js', 'block-wishlist-button.js');
    }
    return SWISH_SCRIPT_FALLBACK;
  }

  function loadSwishScript() {
    if (customElements.get('wishlist-button-block')) return Promise.resolve();
    if (swishScriptPromise) return swishScriptPromise;

    swishScriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-joyee-swish-bridge]');
      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = resolveSwishScriptSrc();
      script.type = 'module';
      script.defer = true;
      script.setAttribute('data-joyee-swish-bridge', 'true');
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return swishScriptPromise;
  }

  function createBridgeMarkup(productHandle, variantId) {
    return `
      <wishlist-button-block
        data-product-handle="${productHandle}"
        data-variant-id="${variantId}"
        align-self="center"
        align-content="center"
        full-width="false"
        show-icon
        show-text="false"
      ></wishlist-button-block>
    `;
  }

  function initWishlistToggle(toggle) {
    if (!toggle || toggle.dataset.joyeeWishlistReady === 'true') return;
    toggle.dataset.joyeeWishlistReady = 'true';

    const container = toggle.closest('.product-title-container');
    const bridgeHost = container ? container.querySelector('[data-joyee-wishlist-bridge]') : null;
    const sectionId = toggle.dataset.sectionId;
    const productHandle = toggle.dataset.productHandle;
    const selectedVariant = sectionId ? document.getElementById(`SelectedVariant-${sectionId}`) : null;

    let mutationObserver;
    let buttonObserver;
    let bridgeHostObserver;
    let syncTimer;

    if (!container || !bridgeHost || !productHandle) return;

    function getVariantId() {
      return (selectedVariant && selectedVariant.dataset.variantId) || toggle.dataset.initialVariantId;
    }

    function getBridgeButton() {
      return bridgeHost.querySelector(
        'button.wk-button, wk-button button, button[aria-label], button[aria-pressed]'
      );
    }

    function getButtonState(swButton) {
      if (!swButton) return false;

      const label = (swButton.getAttribute('aria-label') || '').toLowerCase();
      const ariaPressed = (swButton.getAttribute('aria-pressed') || '').toLowerCase();
      const className = (swButton.className || '').toLowerCase();
      const dataState = (swButton.getAttribute('data-state') || '').toLowerCase();
      const dataAdded = (swButton.getAttribute('data-added') || '').toLowerCase();
      const text = (swButton.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();

      return (
        ariaPressed === 'true' ||
        label.includes('remove') ||
        label.includes('added') ||
        label.includes('in wishlist') ||
        text.includes('remove') ||
        text.includes('added') ||
        text.includes('in wishlist') ||
        className.includes('is-active') ||
        className.includes(' active') ||
        className.startsWith('active') ||
        className.includes('added') ||
        dataState === 'active' ||
        dataState === 'added' ||
        dataState === 'in-wishlist' ||
        dataAdded === 'true'
      );
    }

    function applyVisualState(isActive) {
      toggle.classList.toggle('is-active', isActive);
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      toggle.setAttribute('aria-label', isActive ? 'Remove from Wishlist' : 'Add to Wishlist');
      toggle.classList.remove('is-loading');
    }

    function syncVisualState() {
      const bridgeButton = getBridgeButton();
      applyVisualState(getButtonState(bridgeButton));
    }

    function scheduleSync(attempts, delay) {
      let remaining = typeof attempts === 'number' ? attempts : 12;
      const interval = typeof delay === 'number' ? delay : 150;

      if (syncTimer) {
        window.clearTimeout(syncTimer);
      }

      function run() {
        syncVisualState();
        remaining -= 1;

        if (remaining > 0) {
          syncTimer = window.setTimeout(run, interval);
        }
      }

      run();
    }

    function watchBridgeButton() {
      if (buttonObserver) buttonObserver.disconnect();

      const bridgeButton = getBridgeButton();
      if (!bridgeButton) return;

      buttonObserver = new MutationObserver(() => {
        syncVisualState();
      });

      buttonObserver.observe(bridgeButton, {
        attributes: true,
        attributeFilter: ['aria-label', 'aria-pressed', 'class', 'data-state', 'data-added']
      });

      syncVisualState();
    }

    function watchBridgeHost() {
      if (bridgeHostObserver) bridgeHostObserver.disconnect();

      bridgeHostObserver = new MutationObserver(() => {
        watchBridgeButton();
        scheduleSync(10, 150);
      });

      bridgeHostObserver.observe(bridgeHost, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }

    function renderBridge() {
      const variantId = getVariantId();
      if (!variantId) return;

      bridgeHost.innerHTML = createBridgeMarkup(productHandle, variantId);

      window.requestAnimationFrame(() => {
        watchBridgeHost();
        watchBridgeButton();
        scheduleSync(16, 180);
      });
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      const bridgeButton = getBridgeButton();
      if (!bridgeButton) return;

      toggle.classList.add('is-loading');

      bridgeButton.click();

      scheduleSync(14, 160);
    });

    if (selectedVariant) {
      mutationObserver = new MutationObserver(() => {
        renderBridge();
      });

      mutationObserver.observe(selectedVariant, {
        attributes: true,
        attributeFilter: ['data-variant-id']
      });
    }

    loadSwishScript()
      .then(() => {
        renderBridge();
      })
      .catch(() => {
        toggle.classList.remove('is-loading');
      });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-joyee-wishlist-button]').forEach(initWishlistToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();